// FileExplorer.js
import { useContext, useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, responsiveFontSizes } from '@mui/material';
import { FileSearchTypes, OutputBuildFiles, OutputFileTypes, SearchOutputFileInput } from '../../../data/interfaces/jobmodels';
import jobService from '../../../data/api/job.service';
import FolderIcon from '@mui/icons-material/Folder';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { showerrormessage, showwarningmessage } from '../../../stores/notificationslice';
import { useAppDispatch, useAppSelector } from '../../../stores/hooks';
import { setisStartTrue } from '../../../stores/jobsslice';
import { CurrentFolderContext } from '../jobsmain';



const searchOutputFileInputsList: (SearchOutputFileInput | null | undefined)[] = [];


const BuildFileStatus = () => {
  const { activeJob,setActiveJob } = useContext(CurrentFolderContext);
  const dispatch = useAppDispatch();
  const [fileData, setFileData] = useState<OutputBuildFiles[]>([]);
  const [inputData, setInputDate] = useState<SearchOutputFileInput | null | undefined>(null);
  const [initialFetchCompleted, setInitialFetchCompleted] = useState(false);

  useEffect(() => {
    //if (initialFetchCompleted) return;
    
    if(!activeJob ){
     
    fetchData(inputData);
    }
     // setInitialFetchCompleted(true);
    
    
  }, [initialFetchCompleted, inputData]);

  useEffect(() => {
    if (activeJob) {
      fetchData({

        ParentSearchType :activeJob.TypeId==1? FileSearchTypes.Station:FileSearchTypes.Release, TypeId: activeJob.Id,
        IncludeJobsWithoutFile: true
      });
      
    }
    
  }, [activeJob]);


  const fetchData = async (inputs: SearchOutputFileInput | null | undefined) => {
    //if(!inputs)return;
   
    try {
      jobService.GetOutputFiles(inputs).then((response) => {
      
        if(response.data.length <= 0)
        {
            dispatch(showwarningmessage('No files present.'));
        }
        else
        {
          setFileData(response.data);
        }
        
        
      });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleNavigate = (item: OutputBuildFiles, filename: string) => {
    const newinputs: SearchOutputFileInput = {
      ParentSearchType: item.SearchType,
      TypeId: item.TypeId,
      UserId: 1,
      StartDate: '',
      EndDate: '',
      IncludeJobsWithoutFile: false
    }


    searchOutputFileInputsList.push(inputData);
    setInputDate(newinputs);

    fetchData(newinputs);
    dispatch(setisStartTrue());

  };


  const handleBackButtonClick = () => {
    if (fileData) {
      let newinputs: SearchOutputFileInput = {
        ParentSearchType: fileData[0].LegacySearchType,
        TypeId: fileData[0].LegacyTypeId,
        UserId: 1,
        StartDate: '',
        EndDate: '',
        IncludeJobsWithoutFile: false
      }

      fetchData(newinputs);
    }
  };


  const downloadFile = async (filename: string, typeId: number, searchType: number) => {

    const response = await jobService.getFileDownload(filename, typeId, searchType).then((response) => {

      if (!response)
        return;
      if (filename.includes('.')) {
        const blob = new Blob([response.data]);

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        a.download = filename;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      } else {
        const blob = new Blob([response.data], { type: 'application/zip' });


        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        a.download = filename + '.zip';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      }
    }

    ).catch((Error) => {
      dispatch(showerrormessage("File not found!"))

    });

  };

  function BlankFunc(): void {

  }
  return (


    <TableContainer sx={{bgcolor:'#fff',p:2}} >
      {(fileData.length > 0 && fileData.findIndex(a=>a.Name=="builds") >-1) ? null :
        <Button variant="outlined" onClick={() => handleBackButtonClick()} sx={{ marginBottom: '10px' }}>
          Back
        </Button>

      }
      {/* {
        fileData.length&&fileData[0].LegacyItems.length?
        fileData[0].LegacyItems.map((leg)=>{
          return(
            <div>{leg.Name}</div>
          )
        }):null
      } */}

      <Table>
        <TableHead>
          <TableRow>

            <TableCell>Name</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Created Date</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>Download</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fileData.map((item: OutputBuildFiles) => (

            <TableRow hover={true} key={item.TypeId}>

              <TableCell onClick={item.OutputFileType === OutputFileTypes.Folder ? () => handleNavigate(item, item.Name) : () => BlankFunc()}>
                <Box component='div' sx={{ display: 'flex', alignItems: 'center', mr: 1, cursor: 'pointer' }} >
                  {


                    item.OutputFileType === OutputFileTypes.Folder ? (<FolderIcon sx={{ cursor: 'pointer', color: '#FFC000' }} />) : (<FilePresentIcon color='primary' />)}
                  {item.Name && item.Name.toUpperCase()}
                </Box>

              </TableCell>
              <TableCell>{item.SizeInKB&&item.SizeInKB>1024?Math.round(item.SizeInKB/1024):item.SizeInKB} {item.SizeInKB?item.SizeInKB>1024?'KB':'Bytes':''}</TableCell>
              <TableCell>{item.CreatedDate}</TableCell>
              <TableCell>{item.CreatedBy}</TableCell>
              <TableCell>
                {

                  // item.OutputFileType ===  OutputFileTypes.File? (<FileDownloadIcon onClick={()=>downloadFile(item.Name,item.TypeId)} color='primary' sx={{ cursor: 'pointer' }}/>):''}
                  ([1,2,6].findIndex(a=>a==item.SearchType)<0) ? (<FileDownloadIcon onClick={() => downloadFile(item.Name, item.TypeId, item.ParentSearchType)} color='primary' sx={{ cursor: 'pointer' }} />) : ''}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

  );
};

export default BuildFileStatus;
